export const getCanvaFileId = (value: string) => {
  const trimmedValue = value.trim();

  try {
    const url = new URL(
      trimmedValue.includes("://") ? trimmedValue : `https://${trimmedValue}`,
    );
    const pathSegments = url.pathname.split("/").filter(Boolean);

    const indexOfDesign = pathSegments.indexOf("design");
    if (indexOfDesign === -1) {
      return null;
    }

    return pathSegments[indexOfDesign + 1] || null;
  } catch {
    const pathSegments = trimmedValue.split("/").filter(Boolean);
    const indexOfDesign = pathSegments.indexOf("design");
    if (indexOfDesign === -1) {
      return null;
    }

    return pathSegments[indexOfDesign + 1] || null;
  }
};
